(function () {
  'use strict';

  // "27,5x120" (cm) → m² por unidade. NaN se o metafield faltar ou for inválido.
  function parseUnitArea(sizeString) {
    if (!sizeString) return NaN;
    var parts = sizeString.split('x').map(function (part) {
      return parseFloat(part.trim().replace(',', '.'));
    });
    if (parts.length < 2 || !isFinite(parts[0]) || !isFinite(parts[1]) || parts[0] <= 0 || parts[1] <= 0) {
      return NaN;
    }
    return (parts[0] / 100) * (parts[1] / 100);
  }

  function fillNumber(template, value) {
    if (/\d+([.,]\d+)?/.test(template)) {
      return template.replace(/\d+([.,]\d+)?/, value);
    }
    return value + ' ' + template;
  }

  function formatArea(value) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return String(Math.round(value * 100) / 100).replace('.', ',');
    }
  }

  function updateResult(span) {
    var unitArea = parseUnitArea(span.dataset.productSize);
    if (!isFinite(unitArea)) return;

    var wrapper = span.closest('.calculator__quantity-wrapper');
    var input = wrapper && wrapper.querySelector('.quantity-selector__input');
    var quantity = input ? parseInt(input.value, 10) : 1;
    if (!isFinite(quantity) || quantity < 1) quantity = 1;

    span.textContent = fillNumber(span.dataset.resultTemplate || '', formatArea(quantity * unitArea));
  }

  function updateAll() {
    document.querySelectorAll('.calculator__quantity-result[data-product-size]').forEach(updateResult);
  }

  // Delegação no document: sobrevive ao re-render do quantity-selector
  // quando a variante muda (o tema substitui o nó inteiro).
  document.addEventListener('input', function (event) {
    if (event.target.closest && event.target.closest('.calculator__quantity-wrapper')) updateAll();
  });
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('.calculator__quantity-wrapper')) updateAll();
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.calculator__quantity-wrapper .quantity-selector__button')) {
      requestAnimationFrame(updateAll);
    }
  });
  document.addEventListener('variant:change', function () {
    requestAnimationFrame(updateAll);
  });
  document.addEventListener('shopify:section:load', updateAll);

  if (document.readyState === 'complete') {
    updateAll();
  } else {
    document.addEventListener('DOMContentLoaded', updateAll);
  }
})();
